import React from 'react';
import {
   Image,
   ImageBackground,
   Platform,
   StatusBar,
   Text,
   TouchableOpacity,
   View,
} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {useNavigation} from '@react-navigation/native';
import {
   BACK_ARROW_HOVER_TINT_COLOR,
   BUTTON_HOVER_COLOR,
   FONT_FAMILY_MEDIUM,
   FONT_FAMILY_REGULAR,
   appBackground,
   appBackgroundWhiteBG,
   attestationText,
   hoverBtnBgColor,
   isHoverEnabled,
   isMacOS,
   isWeb,
   primaryColor500,
   primaryColor800,
   white,
} from '../../utils/utils';
import {CopyRight} from '../../utils/CopyRight';
import UISvg from '../../components/svg';
import {isMobileOnly, isSafari} from 'react-device-detect';
import {setSignIn} from '../../redux/slices/AuthSlice';
import {logoutHandler} from '../../service/network_access';
import {BackArrowLink} from '../../components/common';
import {useSafeAreaInsets} from 'react-native-safe-area-context';

const Attestation = () => {
   const isLandscapemode = useSelector(selectScreenOrientation);
   const navigation = useNavigation();
   const dispatch = useDispatch();
   const [isHover, setHover] = React.useState(false);
   const [btnHover, setBtnHover] = React.useState(false);
   const insets = useSafeAreaInsets();
   const statusBarHeight = insets.top;
   return (
      <View
         style={{
            flex: 1,
            backgroundColor: white,
            alignItems: 'center',
            ...Platform.select({
               web: {
                  height: '100vh',
                  flex: null,
               },
            }),
         }}>
         <View
            style={{
               backgroundColor: '#003DA6',
               alignItems: 'flex-start',
               width: '100%',
               height:
                  Platform.OS === 'windows'
                     ? 70
                     : Platform.OS === 'web' || Platform.OS === 'macos'
                     ? 64
                     : Platform.OS === 'ios'
                     ? statusBarHeight + 48
                     : 90,
            }}>
            <UISvg
               height={'100%'}
               width={Platform.OS === 'web' ? '100%' : '200%'}
               x1="0%"
               y1="0%"
               x2="0%"
               y2="100%"
               offset={['0%', '100%']}
               stopColor={['#001F53', '#001F53']}
               stopOpacity={['0', '1']}
               rectWidth={'100%'}
               rectHeight={isMacOS ? 64 : '100%'}
            />
            <View
               style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  flex: 1,
                  marginTop:
                     Platform.OS === 'ios'
                        ? statusBarHeight
                        : Platform.OS === 'android'
                        ? StatusBar.currentHeight
                        : 0,
                  justifyContent: 'space-between',
                  marginStart: 10,
               }}>
               <BackArrowLink
                  onPress={() => {
                     const user = {
                        isLoggedIn: false,
                        userName: '',
                     };
                     Platform.OS === 'web'
                        ? logoutHandler()
                        : dispatch(setSignIn(user));
                  }}
               />
               {/* <TouchableOpacity
                     style={{
                        padding: 10,
                        alignContent: 'center',
                     }}
                     onMouseEnter={() => {
                        setHover(true);
                     }}
                     onMouseLeave={() => {
                        setHover(false);
                     }}
                     onPress={() => {
                        const user = {
                           isLoggedIn: false,
                           userName: '',
                        };
                        Platform.OS === 'web'
                           ? logoutHandler()
                           : dispatch(setSignIn(user));
                     }}>
                     <Image
                        source={require('../../assets/back_arrow.png')}
                        style={{
                           width: 16,
                           height: 16,
                           top: 0,
                           marginLeft: 10,
                           tintColor: isHover
                              ? BACK_ARROW_HOVER_TINT_COLOR
                              : '#FFF',
                        }}
                     />
                  </TouchableOpacity> */}
               <Text
                  style={{
                     fontSize: 16,
                     fontWeight: isLandscapemode ? '500' : '700',
                     fontFamily: FONT_FAMILY_REGULAR,
                     color: 'white',
                     marginStart: 21,
                  }}>
                  Please Read: User Attestation
               </Text>
            </View>
         </View>
         <Text
            style={{
               flex: 1,
               fontSize: isLandscapemode ? 18 : 12,
               fontWeight: '400',
               fontFamily: FONT_FAMILY_REGULAR,
               color: 'black',
               paddingHorizontal: isLandscapemode ? 100 : 16,
               paddingTop: 16,
               width: '100%',
               letterSpacing: 0.5,
               paddingBottom: 112,
            }}>
            {attestationText}
         </Text>
         <TouchableOpacity
            style={[
               {
                  backgroundColor: btnHover ? hoverBtnBgColor : primaryColor500,
                  minHeight: 48,
                  // marginVertical: isLandscapemode ? 50 : 64,
                  marginHorizontal: 16,
                  borderRadius: 6,
                  width: isLandscapemode ? 150 : '90%',
                  justifyContent: 'center',
                  bottom:
                     isWeb && isMobileOnly ? 20 : isLandscapemode ? 44 : 20,
               },
               !(isSafari && isHoverEnabled) && {
                  position: isWeb
                     ? isMobileOnly
                        ? 'fixed'
                        : 'fixed'
                     : 'absolute',
               },
            ]}
            onMouseEnter={() => {
               setBtnHover(true);
            }}
            onMouseLeave={() => {
               setBtnHover(false);
            }}
            onPress={() => {
               navigation.navigate('AttestationProfile');
            }}>
            <View
               style={{
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignContent: 'center',
                  alignItems: 'center',
               }}>
               <Text
                  style={{
                     color: 'white',
                     fontSize: 16,
                     fontWeight: '500',
                     textAlign: 'center',
                     fontFamily: FONT_FAMILY_MEDIUM,
                  }}>
                  Accept
               </Text>
               <Image
                  source={require('../../assets/double_tick.png')}
                  style={{marginStart: 10, width: 17, height: 10}}
               />
            </View>
         </TouchableOpacity>
         {isLandscapemode && (
            <View
               style={{
                  position: isWeb ? 'fixed' : 'absolute',
                  height: 40,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  paddingTop: 4,
                  paddingBottom: 6,
                  backgroundColor: appBackgroundWhiteBG,
               }}>
               <CopyRight
                  screenOrientation={isLandscapemode}
                  isCopyrightShown={isLandscapemode ? true : false}
               />
            </View>
         )}
      </View>
   );
};

export default Attestation;
